import i18next from 'i18next';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const ComparisonValue = ({fieldName, showLabel}) => {
  return <CalculatorStandardInput
    fieldName={`${fieldName}.${0}`}
    isRequired
    uxVariant="criteriaInput"
    variant="standard"
    label={`${
      showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
    }`}
    placeholder={i18next.t(
      `calculator.dialog.create.placeholder.selectValues`
    )}
    validate={() => null}
    triggerOnContinue
  />
}

export default ComparisonValue;